import { isValid } from 'date-fns';
import { fCurrency, fNumber } from '@/utils/formatNumber';
import { fDateAbbrevMonth, fDateTime } from '@/utils/formatTime';
import { User } from '@/features/users/shared/types';
import {
  InvoiceDryRun,
  InvoiceDryRunProviderInvoicePreview,
  InvoiceDryRunStatus,
} from '../types';

export const isUpdatingDryRun = (
  status?: InvoiceDryRunStatus | string | null
) => status === 'QUEUED' || status === 'RUNNING';

export const formatDryRunDate = (
  value?: string | number | Date | null,
  format = 'dd MMM yyyy'
) => {
  if (!value) return '-';
  const date = new Date(value);
  if (!isValid(date)) return '-';
  return fDateAbbrevMonth(date, format);
};

export const formatDryRunDateTime = (value?: string | number | Date | null) => {
  if (!value) return '-';
  const date = new Date(value);
  if (!isValid(date)) return '-';
  return fDateTime(date);
};

export const formatDryRunDateRange = (
  from?: string | null,
  to?: string | null
) => `${formatDryRunDate(from)} - ${formatDryRunDate(to)}`;

export const formatDryRunCount = (
  value: number | string | null | undefined,
  status?: InvoiceDryRunStatus | string | null
) => {
  if (value === null || value === undefined || value === '') {
    return isUpdatingDryRun(status) ? 'Updating' : '-';
  }

  return fNumber(value);
};

export const formatDryRunMoney = (value?: number | string | null) => {
  if (value === null || value === undefined || value === '') return '-';
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return '-';
  return fCurrency(numericValue);
};

export const formatRequestedBy = (
  requestedBy?: InvoiceDryRun['requested_by']
) => {
  if (!requestedBy) return '-';
  if (typeof requestedBy === 'string') return requestedBy;

  const user = requestedBy as User;
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  return name || user.email || String(user.id || '-');
};

export const getDryRunInvoiceLineItems = (
  invoice?: InvoiceDryRunProviderInvoicePreview | null
) => invoice?.line_items || [];
